import type { PriorityAlertItem } from "app/pages/activation/types/api";
import type { AlertTabId } from "app/pages/activation-alerts/components/tabs/config";
import { AlertVariant } from "app/pages/activation-alerts/types/PlatformAlerts";

export type PriorityAlertNavigationExtras = {
    country: number | string;
    tab: AlertTabId;
    alertsType?: "keywords" | "pages";
};

export const getPriorityAlertNavigationExtras = (alert: PriorityAlertItem): PriorityAlertNavigationExtras => {
    const { alertType, country } = alert;

    switch (alertType) {
        case AlertVariant.SocialPosts:
            return { country, tab: "socialMedia" };
        case AlertVariant.WebsiteContent:
            return { country, tab: "websiteContent" };
        case AlertVariant.NewPages:
            return { country, tab: "seoAlerts", alertsType: "pages" };
        case AlertVariant.NewKeywords:
            return { country, tab: "seoAlerts", alertsType: "keywords" };
        case AlertVariant.All:
        default:
            return { country, tab: "seoAlerts" };
    }
};
